export default __webpack_public_path__ + "static/media/2119.532b5585.png";